import { gsap, Power1, TweenMax } from "gsap";
//const bodyScrollLock = require('body-scroll-lock');


document.addEventListener('DOMContentLoaded', () => {

    const nav = document.querySelector('.js-nav'),
          hamburger = document.querySelector('.js-hamburger');

    const init = ()=> {
        
        let parent = nav.querySelector('.js-parent');
        
        const toggle = function(ev, section, op) {
            TweenMax.to(section, 0.4, {
                height: ev,
                opacity: op,
                immediateRender: false,
                ease: Power1.easeOut
            });
        }
        
        const open_submenu = (e)=> {
            const _that = e.currentTarget,
                  _height = 0;
                        
            if (_that.classList.contains('is-active')) {
                _that.classList.remove('is-active');
                toggle(_height, _that.parentNode.querySelector('ul'), 0);
                
            } else {
                _that.classList.add('is-active');    
                toggle('auto', _that.parentNode.querySelector('ul'), 1);
            }
            e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        }
        
        if (parent) {
            parent.addEventListener('click', open_submenu);
        }

        window.hideMenu = ()=> {
            if (document.querySelector('.js-nav').classList.contains('is-visible')) {
                document.querySelector('.js-nav').classList.remove('is-visible');
                document.querySelector('.js-hamburger').classList.remove('is-active');                
                document.documentElement.classList.remove('is-animated');
                document.documentElement.classList.remove('mobile-menu');
                setTimeout(()=> {
                    document.querySelector('.js-nav').classList.remove('is-block');
                    document.querySelector('.js-nav').classList.remove('is-animated');
                }, 500);   
                document.documentElement.removeAttribute('style'); 
                hamburger.classList.remove('is-active');         
            }            
        };

        const showMenu = () => {
            nav.classList.add('is-block');
            document.documentElement.setAttribute('style', 'overflow: hidden');
            hamburger.classList.add('is-active');
            
            setTimeout(() => {
                document.documentElement.classList.add('mobile-menu');
            }, 10);

            setTimeout(() => {
                nav.classList.add('is-visible');
                showLinks();
            }, 100);    
            
            const showLinks = () => {
                gsap.utils.toArray(".js-menu").forEach((elem) => {            
                    const blocks = elem.querySelectorAll(".js-item"),
                          tl = gsap.timeline().delay(.2).eventCallback("onComplete", () => {
                              document.documentElement.classList.add('is-animated');
                          })

                    .from(blocks, {
                        y: -60,
                        duration: .8,
                        opacity: 0,
                        stagger: {
                            each: 0.1
                        },
                        ease: 'elastic.out(1, .8)',
                    });
                });
            };        
        };

        const toggleMenu = (e) => {
            nav.classList.contains('is-visible') ? hideMenu() : showMenu();
        };

        hamburger.addEventListener('click', toggleMenu);

        // Hide menu on ESC

        document.addEventListener('keydown', (evt) => {
            // evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key == "Escape" || evt.key == "Esc");
            } else {
                isEscape = (evt.keyCode == 27);
            }
            if (isEscape) {
                hideMenu();
            }
        });
        
        let mediaQuery = '(min-width: 1025px)',
            mediaQueryList = window.matchMedia(mediaQuery);
        
        mediaQueryList.addEventListener('change', event => {
            event.matches ? hideMenu() : false;
        })
        
        mediaQueryList.matches ? hideMenu() : false;
    };

    nav ? init() : false;

}, false);